import {ICard} from "../models/card/ICard";
import {IDeckEditorFilter} from "../models/IDeckEditorFilter";
import {config} from "../config";

export function cardMatchesDeckFilter(
    cardId: number,
    card: ICard | undefined,
    filter: IDeckEditorFilter,
): boolean {
    if (!card) return false;

    // спец-режим для mana_card: тільки whitelist, rarity ігноруємо
    if (filter.type === "mana_card") {
        return config.MANA_CARDS.has(cardId);
    }

    const typeOk = filter.type === "all" || card.type_card === filter.type;
    const rarityOk = filter.rarity === "all" || card.level === Number(filter.rarity);

    return typeOk && rarityOk;
}